











import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GOptionalRadio',
  computed: {},
  methods: {},
})
export default class GOptionalRadio extends Vue {
  @Prop() label: string;
  @Prop() text: string;
  @Prop() condition: boolean;
  @Prop() tooltipText: string;
  @Prop() dataTestid: string;
  mounted() {}
}
